import { toZonedTime, fromZonedTime } from 'date-fns-tz';

// Fase timezones (sevilla-timezones): la grilla de tareas/calendario (ComponentTaskHoy.jsx)
// posiciona y edita horas usando los getters LOCALES de `Date` (getHours, getDate, etc.), que
// siempre reflejan el timezone del SISTEMA OPERATIVO del navegador -- nunca `user.timezone`. El
// usuario pidió explícitamente que el dispositivo no influya: si configura un timezone distinto
// al de su computadora física, la grilla debe seguir usando el configurado.
//
// `toUserZoned`/`fromUserZoned` envuelven `date-fns-tz` (ya dependencia del backend, misma
// versión) para no reinventar la matemática de DST/offsets a mano.

// Dado un instante real (UTC), devuelve un objeto Date cuyos getters LOCALES (getHours,
// getMinutes, getDate, getDay, etc.) reflejan el wall-clock en `timeZone` -- se usa para LEER
// (posicionar en la grilla, calcular "hoy", generar headers de columnas).
export function toUserZoned(date, timeZone) {
    return toZonedTime(date, timeZone);
}

// Inverso: dado un Date cuyos getters LOCALES representan el wall-clock que el usuario quiso
// (ej. construido con `new Date(year, month, day, hour, minute)` a partir de una posición de
// grilla o un drag), devuelve el instante UTC real que hay que guardar en la base de datos.
export function fromUserZoned(date, timeZone) {
    return fromZonedTime(date, timeZone);
}
